<ng-container *tIfHasRole="[userRoles.CMExternal, userRoles.CMInternal]">
  <t-aircall-wrapper />
</ng-container>
